import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbErrorCircle: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 24, ...props }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} {...props}>
      <g id='Box'>
        <rect fill='none' width={size} height={size} />
      </g>
      <g id='Final_icons_-_Common' data-name='Final icons - Common'>
        <path
          fill={fill}
          d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm4.71,14.29-1.42,1.42L12,13.41l-3.29,3.3L7.29,15.29,10.59,12,7.29,8.71,8.71,7.29,12,10.59l3.29-3.3,1.42,1.42L13.41,12Z'
        />
      </g>
    </svg>
  );
};
